import { createAction } from '@ngrx/store';

export const forceReportsDataUpdate = createAction('[Reports] Force reports data update');

export const reportsDataUpdateSuccess = createAction('[Reports] Data updated successfully');

export const reportsDataUpdateError = createAction('[Reports] Data update error');
